<template>
    <div class="col-xs-12 col-sm-6 col-md-3">
        <div class="card-element m-b-xl" :class="[backgroundClass]" :style="backgroundImage">

            <span class="close-wrapper" @click="$emit('remove-item', id)">
                <a href="javascript:void(0)" title="Remove"><i class="icon icon-close"></i></a>
            </span>

            <div class="card-element--top-section" data-href="#" @click.prevent="onItemClick">
                <i class="card-icon yellow-text" :class="[cardIcon]"></i>

                <h1 class="card-element--headline">
                    <span v-html="content.block1">La demolizione Brussada</span>
                </h1>

                <p class="card-element--text">
                    <span v-if="content.block2" v-html="content.block2">Sottotitolo lorem ipsum dolor sit lorem ipsum</span>
                    <span v-if="content.block3" v-html="content.block3" class="card-date only-list">1969</span>
                </p>
            </div>

            <div class="card-element--bottom-section clearfix" data-mh="favorites-card-mh-1">
                <div v-if="content.block3" class="card-date only-card" v-html="content.block3">1969</div>

                <div v-if="tag" class="band-fondo-eni">{{ tag }}</div>

                <div class="action-icon-container">
                    <ul>
                        <li v-if="digitalized">
                            <a href="javascript:void(0)">
                                <i class="icon-eye-full"></i>
                            </a>
                        </li>

                        <li v-if="inSede" class="reserved-doc-info">
                            <a onclick="showRequestInfoModal('requestInfo')"
                               class="icon-info-container js-popoverOnlyDesktop" data-toggle="popover"
                               data-html="true" data-trigger="hover"
                               :data-content="message('richiedi.header.prompt.appuntamento.help')"
                               data-placement="left">
                                <i class="icon-info"></i>
                            </a>
                        </li>

                        <li class="favourite"></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import message from '../i18n'

    const ID_RE = /^IT-ENI-([A-Z]+)(\d{4})-(\d{6,10})$/;

    export default {
        name: "Card",
        props: {
            id: String,
            content: Object, // { block1:"", block2:"", block3:"" }
            tag: String,
            imagePath: String,
            link: Object,
            digitalized: Boolean,
            inSede: Boolean
        },
        computed: {
            cardIcon() {
                const groups = this.id.match(ID_RE);

                if(groups === null){
                    return 'icon-document' // default se incontra un id non valido, non dovrebbe mai succedere
                }

                const archive = groups[1];

                switch (archive) {
                    case 'ST':
                        return 'icon-document';
                    case 'FT':
                        return 'icon-picture';
                    case 'AV':
                        return 'icon-audiovisual';
                    case 'BIB':
                        return 'icon-magazine';
                    case 'DISEGNI':
                        return 'icon-drawing';
                }

                // default se si tratta di un archivio non gestito
                return 'icon-document'
            },
            backgroundClass() {
                return this.backgroundImage === "" ? 'only-bg-gradient' : ''
            },
            backgroundImage() {
                if(this.imagePath) {
                    let imgPrefix = this.imagePath.startsWith("http") ? "" : window.BOOKMARK_CONF.viewport_url + "/500x/";
                    return "background-image: url('" + imgPrefix + this.imagePath + "')"
                }

                return "";
            }
        },
        methods: {
            message: message,
            onItemClick() {
                const otherLang = window.BOOKMARK_CONF.lang === 'it' ? '/en/' : '/it/';
                const uri = this.link['href'].replace(otherLang, '/' + window.BOOKMARK_CONF.lang + '/');

                window.open(uri, this.link['target']);
            }
        }
    }
</script>

<style scoped>

</style>